export default "/images/0cf054cdac0f23318357346b16a75d1b.avif";